import NeutralButton from 'src/components/buttons/NeutralButton';
import { StyledIcon } from 'src/styles/theme/components/NGIcon/NGIcon.styles';
import { EMediaQuery, ESize } from 'src/styles/theme/utils/enums';
import { addMarginStyles, addTransition, mq } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';
import { ESocialShareType } from './ShareProfile.enum';
import { TShareProfileStylesProps } from './ShareProfile.type';

const fixedStyles = (p: TShareProfileStylesProps) => css`
	${p.shareType === ESocialShareType.profile || p.shareType === ESocialShareType.app
		? `
		position: fixed;
		
		bottom: ${p.theme.spacing[ESize.xs]};
		right: 50%;
		margin-right: -90px;
		align-items: center;
		`
		: 'margin-top: 36px;'}

	display: flex;
	flex-direction: column;
	justify-content: center;

	width: fit-content;
	height: fit-content;

	${p.shareType === ESocialShareType.app ? `z-index: 600;` : `z-index: 200;`}

	${mq(EMediaQuery.sm, `transform: scale(0.8);`)}

	${mq(
		EMediaQuery.md,
		`
			right: ${p.theme.spacing[ESize.xs]};
			margin-right: unset;
			& > p {
				display: none;
			}
		`
	)}

	${p.shareType === ESocialShareType.profile
		? `
		${
			p.isShareApiSupported
				? `
			${mq(EMediaQuery.sm, `bottom: 40%; right: 0px;`)}
			`
				: `
			${mq(EMediaQuery.sm, `bottom: 30%; right: 0px;`)}
			`
		}
		`
		: ''}

		${p.shareType === ESocialShareType.app
		? `
			${mq(
				EMediaQuery.md,
				`
					bottom: 40%;
					right: 2px;
					margin-right: 0;
			`
			)}`
		: ''}
`;

const mobileQuestStyles = (p: TShareProfileStylesProps) => css`
	position: relative;
	display: flex;
	flex-direction: column;

	align-items: center;
	justify-content: center;
`;

export const StyledShareProfile = styled.div<{
	isShareApiSupported?: boolean;
	isHidden?: boolean;
	isMobileQuest?: boolean;
	shareType: ESocialShareType;
}>`
	${(p) => css`
		${addMarginStyles(p)}

		${StyledIcon} {
			color: #66573f;
		}

		a {
			${addTransition()}
			@media (hover: hover) {
				&:hover {
					opacity: 0.5;
				}
			}
		}

		${addTransition()}
		${p.isHidden ? `opacity: 0; pointer-events: none;` : ``}

	${p.isMobileQuest ? mobileQuestStyles(p) : fixedStyles(p)}
	`}
`;

export const NeutralButtonEx = styled(NeutralButton)<{ isActive?: boolean }>`
	position: relative;

	display: flex;
	justify-content: center;
	align-items: center;

	width: 60px;
	height: 60px;

	& > span {
		position: absolute;
		${addTransition()}

		${(p) =>
			p.isActive
				? css`
						&:nth-child(1) {
							opacity: 0;
							transform: translateY(-50%) rotate(45deg);
						}
						&:nth-child(2) {
							opacity: 1;
							transform: translateY(0) rotate(0);
						}
				  `
				: css`
						&:nth-child(1) {
							opacity: 1;
							transform: translateY(0) rotate(0);
						}
						&:nth-child(2) {
							opacity: 0;
							transform: translateY(50%) rotate(-45deg);
						}
				  `}
	}
`;
